/**
 * 全局数据
 */
import api from '../../api/api'
import * as types from '../mutation'
import * as pi from '../../../package.json'
// console.debug("common> pi:%o", pi);
const VERSION = pi.version; //"1.3.8";

const state = {
    appVer: VERSION,
    loadingStatus: false,
}

const getters = {
    getAppVer: state => state.appVer,
    getLoadingStatus: state=> state.loadingStatus,
}

const actions = {
   updateLoadingStatus ({ commit }, loading_status) {
        // console.debug("updateLoadingStatus> loading_status:%o", loading_status);
        commit(types.COM_LOADING_STATUS, { loading_status })
    },
}

const mutations = {
  [types.COM_LOADING_STATUS] (state, { loading_status }) {
      let status = false
      // console.debug("COM_LOADING_STATUS> loading_status:%o", loading_status);
      if(loading_status === true){
        status = true;
      }
      state.loadingStatus = status
  },
}

export default{
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js